import React from 'react'
import SeltousSuryoday from './component/SeltousSuryoday'
import CarensSuryoday from './component/CarensSuryoday'
import JinkiesSuryoday from './component/JinkiesSuryoday'
import CarensKredPayPayin from './component/CarensKredPayPayin'

function index() {
  return (
    <>
    <SeltousSuryoday/>
    <CarensSuryoday/>
    <JinkiesSuryoday/>
    <CarensKredPayPayin/>
    </>
  )
}

export default index